import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';

import useI18n from '../../hooks/use-i18n';

import '../../styles/rating.scss';

export default function UserRating(props) {
  const { isActive, onClick, type, dataKey, skuString } = props;
  const i18n = useI18n();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);
  return (
    <div className="rating-card-wrapper">
      <div className="rating-header">
        <div className="rating-wrapper">
          <span className="rating" data-lokalise="" data-key={dataKey}>
            {type ? (
              <>
                {type}
                &nbsp;
              </>
            ) : (
              <>
                {isMobile ? i18n.t('rating_card.reviews') : i18n.t('rating_card.user_reviews')}
                &nbsp;
                <span className="ruk_rating_snippet_review_count" data-sku={skuString} />
              </>)}

          </span>
        </div>
        <span
          className={`plus ${isActive ? 'active' : ''}`}
          onClick={onClick}
          role="presentation"
        />
      </div>
    </div>
  );
}

UserRating.propTypes = {
  isActive: PropTypes.bool,
  onClick: PropTypes.func,
  type: PropTypes.string,
  dataKey: PropTypes.string,
  skuString: PropTypes.string
};

UserRating.defaultProps = {
  isActive: false,
  onClick: () => { },
  type: '',
  dataKey: '',
  skuString: ''
};
